import React from 'react';
import { hashHistory, Link, browserHistory } from 'react-router'; 
import {connect } from 'react-redux';
import IconButton from 'material-ui/IconButton';
import BackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import AppBar from 'material-ui/AppBar';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {logoutUser} from '../../actions/authActions';

const styles = {
  smallIcon: {
    color: '#fff',
    fontSize: 22
  },
  mediumIcon: {
    color: '#fff',
    width: 40,
    height: 40,
  },
  medium: {
    width: 60,
    height: 60
  },
    largeIcon: {
        color: '#fff',
        width: 28,
        height: 28
  }
}




class HeaderSmall extends React.Component {
  
     constructor(props) {
      super(props);
           
      this.goBackLogic = this.goBackLogic.bind(this);
    }
    
    goBackLogic(){

      if(this.props.goBackFunction) {
        this.props.goBackFunction();
      }
      else{
        browserHistory.goBack();
      }
       
    }

    logoutDasUser = (e, t) => {
    
      if(t.props.primaryText === "Sign out")
        {
          localStorage.removeItem('id_token');
          this.props.logoffUser();
          hashHistory.push('/?signout=true');
        }
    }
  
    render() {

        
        return (
              <header id="dasHeader" className="headerSmall">
                
                <AppBar className="appbar" title={this.props.title}              
                iconElementLeft={   <IconButton
                            iconStyle={styles.largeIcon}
                            style={styles.large}
                            >
                            <BackIcon onClick={this.goBackLogic} />
                            </IconButton>}
                iconElementRight={ 
                    <IconMenu onItemTouchTap={this.logoutDasUser}
                        // {...props}
                        iconButtonElement={
                          <IconButton  iconStyle={styles.largeIcon}><MoreVertIcon /></IconButton>
                        }
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                      >
                        {/* <MenuItem primaryText="Refresh" /> */}
                        {/* <MenuItem primaryText="Help" containerElement={<Link to={"/help"} />} /> */}
                        {/* <MenuItem primaryText="Logs" containerElement={<Link to={"/logs"} />} /> */}
                        {/* {this.props.member && (this.props.member.EmailAddress === "dave@medefy.com") && (
                            <MenuItem primaryText="Logs" containerElement={<Link to={"/logs"} />} />
                        )} */}
                        
                        {/* <MenuItem primaryText="Feedback" /> */}
                        {/* <MenuItem primaryText="Report a Problem" /> */}
                        <MenuItem primaryText="Sign out"  />
                      </IconMenu>

                } />

                 {(this.props.children) && (
                    <div>
                        { this.props.children }
                    </div>
                )}
            </header>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logoffUser: () => {
      dispatch(logoutUser());
    }
  }
}

const mapStateToProps = (state) => ({
  member: state.thisApp.auth.member
})


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderSmall)


// WEBPACK FOOTER //
// ./src/Components/Header/HeaderSmall.js